<template lang="pug">
  .component-create-entity-button
    ModalReveal(:ref="componentId" :key="componentId")
      button.button(slot="trigger") Cash in
      .row
        .column
          label Amount vat included
            input(type="number", v-model="body.amount")
          label Reason
            input(type="text", v-model="body.reason")
        .column
          label Vat
          select(v-model="body.tax")
            option(:value="null") Select vat
            option(v-for="vat in vats", :value="vat.percentage / 100") {{vat.description }} ({{vat.name}} {{vat.percentage}}%)

      ActionButton(slot="footer", :action="save", confirm) Save
      button.button.alert.float-right(slot="footer", @click="$refs[componentId].close()") Cancel

</template>

<script>
import KeplerBackofficeSdk from '../../lib/kepler/backoffice'
import ActionButton from '../../components/structure/ui/ActionButton'
import ModalReveal from '../../components/structure/foundation/ModalReveal'
import MaggieHelper from "../../maggieHelper";
import {EventBus} from "../../eventBus";
import {mapState} from "vuex";

export default {
  name: 'CashInPreauthReveal',
  components: {ActionButton, ModalReveal},
  data() {
    return {
      body: {
        amount: this.preauth.amount,
        reason: null,
        tax: null
      },

    }
  },
  created() {

  },
  methods: {
    save() {
      return KeplerBackofficeSdk.preauth.select(this.preauth.id).cashIn(this.body, () => {
        MaggieHelper.notification('', 'preauth created')
        EventBus.$emit('reload-list')
        this.$refs[this.componentId].close()
      })
    }
  },
  computed: {
    componentId() {
      return `cashInReveal-${this._uid}`
    },
    ...mapState({
      vats: state => state.configuration.vats,
      commonCostTypes: state => state.configuration.commonCostTypes,
    }),
  },
  props: {
    preauth: {
      type: Object,
      default: null,
    }
  }
}
</script>



// WEBPACK FOOTER //
// CashInPreauthReveal.vue?83c8db24